<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/productList' }">产品</el-breadcrumb-item>
                <el-breadcrumb-item>产品{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>
                                </el-form-item>
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNaturalNumber, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'productListEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.commodity_flow_applicable = 1;
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                product_licence_rid: {
                    request_uri: 'productLicencesDropdown',
                    title: '产品批文',
                    ref: 'product_licence_rid_ref',
                    display_name: 'licence_product_name',
                    type: 'dropdown'
                },
                type_code: {
                    request_uri: 'dropdownProductTypeCode',
                    title: '类型',
                    ref: 'type_code_ref',
                    select_value: 'value',
                    type: 'dropdown'
                },
                group_code: {
                    request_uri: 'dropdownProductGroupCode',
                    title: '分组',
                    ref: 'group_code_ref',
                    select_value: 'value',
                    type: 'dropdown'
                },
                master_rid: {
                    request_uri: 'dropdownProducts',
                    title: '主产品',
                    ref: 'master_rid_ref',
                    request_params: { type_code: [15, 25] },
                    type: 'dropdown'
                },
                commodity_flow_applicable: {
                    request_uri: 'dropdownCommodityFlowApplicable',
                    title: 'PPAM默认计算类型',
                    ref: 'commodity_flow_applicable_ref',
                    type: 'dropdown',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                main_min_package_spec_in_delivery_package: { validator: checkNaturalNumber, trigger: 'blur' },
                general_weight: { validator: checkNaturalNumber, trigger: 'blur' },
                value_added_tax_rate: { validator: checkNumber, trigger: 'blur' },
                common_name_standardization_coefficient: { validator: checkNumber, trigger: 'blur' },
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                safety_stock: [{ validator: checkNumber, trigger: 'blur' }],
                dose_spec: [{ validator: checkNumber, required: true, message: '药剂规格必填且须为数字', trigger: 'blur' }],
                min_package_un: [{ required: true, message: '请输入最小包装单位', trigger: 'blur' }],
                min_package_un_code: [{ required: true, message: '请输入最小包装单位编码', trigger: 'blur' }],
                product_licence_rid: [{ required: true, message: '请选择产品批文', trigger: 'blur' }],
                type_code: [{ required: true, message: '请输入类型编码', trigger: 'blur' }],
                group_code: [{ required: false, message: '请输入分组编码', trigger: 'blur' }],
                commodity_flow_applicable: [{ required: true, message: 'PPAM默认计算类型', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                name: this.data.name || '',
                phonic_code: this.data.phonic_code || '',
                dose_spec: this.data.dose_spec || 0,
                main_min_package_spec_in_delivery_package: this.data.main_min_package_spec_in_delivery_package || 0,
                package_postscript: this.data.package_postscript || '',
                min_package_un: this.data.min_package_un || '',
                min_package_un_code: this.data.min_package_un_code || '',
                safety_stock: this.data.safety_stock || 0,
                product_licence_rid: this.data.product_licence_rid || '',
                value_added_tax_rate: this.data.value_added_tax_rate || 0,
                common_name_standardization_coefficient: this.data.common_name_standardization_coefficient || 0,
                trademark_name: this.data.trademark_name || '',
                short_name: this.data.short_name || '',
                specification: this.data.specification || '',
                general_weight: this.data.general_weight || 0,
                group_code: this.data.group_code || '',
                licence_spec_code: this.data.licence_spec_code || '',
                type_code: this.data.type_code || '',
                master_rid: this.data.master_rid || '',
                commodity_flow_applicable: this.data.commodity_flow_applicable || 1
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).product;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'code',
                        'name',
                        'product_licence_rid',
                        'dose_spec',
                        'min_package_un',
                        'min_package_un_code',
                        'safety_stock',
                        'value_added_tax_rate',
                        'general_weight',
                        'phonic_code',
                        'main_min_package_spec_in_delivery_package',
                        'package_postscript',
                        'common_name_standardization_coefficient',
                        'trademark_name',
                        'short_name',
                        'specification',
                        'group_code',
                        'type_code',
                        'licence_spec_code',
                        'master_rid'
                    ]
                },
                {
                    commodity_flow_applicable_label: 'commodity_flow_applicable',
                    group_code_label: 'group_code',
                    type_code_label: 'type_code'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/productList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .productDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'productUpdate';
            } else {
                uri = 'productInsert';
            }

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>